import React from 'react';
import { Box } from '@mui/material';
import { Logo } from '../../../../../assets/logo';
import type { ReportBranding } from '../utils/branding';

interface SlideFrameProps {
  branding?: ReportBranding;
  children: React.ReactNode;
}

/**
 * Branded chrome wrapped around every slide in print/presentation: the PEAK4
 * wordmark (bottom-left) and the client logo (top-right, if set). Matches the
 * UU deck, where each slide carries both marks. The inner content area holds the
 * slide's blocks.
 */
export const SlideFrame: React.FC<SlideFrameProps> = ({ branding, children }) => {
  const clientLogo = branding?.logoUrl;

  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
      {/* Client logo, top-right. */}
      {clientLogo && (
        <Box
          component='img'
          src={clientLogo}
          alt=''
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            maxHeight: 56,
            maxWidth: 200,
            objectFit: 'contain',
            zIndex: 1,
          }}
        />
      )}

      {/* Slide content. */}
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          pb: 5,
        }}
      >
        {children}
      </Box>

      {/* PEAK4 wordmark, bottom-left. */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          height: 28,
          '& svg': { height: 28, width: 'auto' },
          opacity: 0.95,
          zIndex: 1,
        }}
      >
        <Logo />
      </Box>
    </Box>
  );
};
